<template>
  <v-card class="mt-4 pa-8 pt-0">
    <v-form ref="form">
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-text-field
            v-model="model.message"
            class="pb-0"
            label="Текст уведомления"
            :rules="notificationTextRules"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-select
            v-model="model.openWindow"
            :items="windows"
            label="Открыть окно"
            :rules="windowsRules"
          >
          </v-select>
        </v-col>
        <v-col cols="12" class="pb-0" v-if="isNeedUrl">
          <v-text-field v-model="model.url" class="pb-0" label="URL страницы" :rules="urlRules">
          </v-text-field>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-select
            :items="roles"
            v-model="model.roles"
            :rules="rolesRules"
            item-text="name"
            item-value="key"
            label="Роли"
            multiple
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleRolesSelect">
                <v-list-item-action>
                  <v-icon :color="model.roles.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Выбрать все </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-6 mb-4">
          Целевая платформа:
          <v-checkbox
            v-model="model.deviceType"
            label="iOS"
            value="ios"
            dense
            hide-details
            :rules="platformRules"
          >
          </v-checkbox>
          <v-checkbox
            v-model="model.deviceType"
            class="mt-0"
            label="Android"
            value="android"
            dense
            :rules="platformRules"
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12">
          <v-btn class="success" @click="save" dark> Отправить </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="alert" max-width="500px">
      <v-card>
        <v-card-text class="text-lg-center pt-4">
          <div>
            <div class="headline pa-2">{{ alertMessage }}</div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-lg-center">
          <v-col cols="12" align-self-center>
            <v-btn color="primary" @click="alert = false"> Закрыть </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { getRoles, setNotificationSettings } from '@/api/notifications'

export default {
  name: 'push_notifications',
  data() {
    return {
      model: {
        message: '',
        openWindow: '',
        deviceType: [],
        roles: [],
        url: '',
      },
      windows: ['Новости', 'ВПШ', 'Конкурсы', 'Веб-страница'],
      roles: [],
      alert: false,
      alertMessage: '',
      notificationTextRules: [
        (v) => !!v || 'Это поле обязательно',
        (v) => (!!v && v[0].toUpperCase() === v[0]) || 'Текст должен начинаться с заглавной буквы',
        (v) => (!!v && v.length <= 256) || 'Тест не может превышать 256 символов',
      ],
      windowsRules: [(v) => !!v || 'Должно быть выбрано окно'],
      rolesRules: [(v) => Boolean(v.length) || 'Должна быть выбрана минимум одна роль'],
      platformRules: [(v) => Boolean(v.length) || 'Должна быть выбрана минимум одна платформа'],
      urlRules: [
        (v) => !!v || 'Это поле обязательно',
        (v) =>
          RegExp(
            /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/
          ).test(v) || 'Указан не валидный url',
      ],
    }
  },
  computed: {
    isNeedUrl: (vm) => vm.model.openWindow === 'Веб-страница',
    isAllRolesSelected: (vm) => vm.model.roles.length === vm.roles.length,
    icon: (vm) => {
      if (vm.isAllRolesSelected) return 'mdi-close-box'
      if (vm.model.roles.length) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  created() {
    getRoles(this.axios)
      .then((res) => {
        this.roles = res.data
      })
      .catch((err) => {
        this.showSnackbar('Не удалось загрузить список ролей', 'error')
      })
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        const { message, openWindow, deviceType, roles, url } = this.model
        setNotificationSettings(this.axios, message, openWindow, deviceType, roles, url)
          .then((res) => {
            this.alertMessage = res.data.status
            this.alert = true
            this.$refs.form.reset()
          })
          .catch((err) => {
            this.showSnackbar(err, 'error')
          })
      }
    },
    toggleRolesSelect() {
      this.$nextTick(() => {
        if (this.isAllRolesSelected) {
          this.model.roles = []
        } else {
          this.model.roles = this.roles.map((role) => role.key)
        }
      })
    },
  },
}
</script>
